import DescargarXML from 'akasia-components/cliente/orden/seccion-header/DescargarXML';
import DescargarPDFComplemento from 'akasia-components/cliente/orden/seccion-header/DescargarPDFComplemento';
import PropTypes from 'prop-types';
import React from 'react';
import { DropdownButton, Spinner } from 'react-bootstrap';

const HeaderComplementoPago = ({ isActive, vUUIDComplemento, dFechaEmision, vRfcEmisor }) => {
    return (
        <div className="mb-1">
            <div className={`d-flex justify-content-between align-items-center ${isActive === false ? 'border border-danger rounded px-3 py-2 text-danger bg-light shadow-sm' : ''}`}>
                <h5 className="m-0" style={{ color: 'inherit' }}>
                    {isActive === false && <i className="bi bi-exclamation-triangle-fill me-2"></i>}
                    📄 Factura Emitida  →  Complemento de Pago (REP)
                </h5>

                <div className="d-flex align-items-center">
                    {isActive === undefined || isActive === null ? (
                        <span className="me-2">
                            <Spinner animation="border" size="sm" variant="secondary" />
                        </span>
                    ) : (
                        <>
                            <span
                                className="me-2"
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: isActive ? 'green' : 'red',
                                    display: 'inline-block'
                                }}
                            ></span>
                            {isActive ? (
                                <DropdownButton
                                    variant="success"
                                    title="Complemento Activo"
                                    size="sm"
                                >
                                    <DescargarPDFComplemento
                                        vUUIDFactura={vUUIDComplemento}
                                        dFechaEmision={dFechaEmision}
                                        vRfcEmisor={vRfcEmisor}
                                        esFacturaRecibida={false}
                                    />
                                    <DescargarXML
                                        vUUIDFactura={vUUIDComplemento}
                                        dFechaEmision={dFechaEmision}
                                        vRfcEmisor={vRfcEmisor}
                                    />
                                </DropdownButton>
                            ) : (
                                <span className="text-danger">
                                    Complemento Cancelado
                                </span>
                            )}
                        </>
                    )}
                </div>
            </div>
            <hr></hr>
        </div >
    );
};

HeaderComplementoPago.propTypes = {
    isActive: PropTypes.bool,
    vUUIDComplemento: PropTypes.string,
    dFechaEmision: PropTypes.string,
    vRfcEmisor: PropTypes.string
};

export default HeaderComplementoPago;
